module.exports = __webpack_public_path__ + "img/section4-jp1.db06e132.png";